<template>

        <div class="theme-dark">
            <div class="m-content-page">
                <div class="m-navbar-top">
                    <div class="topbar-left-menu float-left">
                        <div class="dropdown m-dropdown-nav">
                            <a id="menu-btn" href="javascript:;" class="nav-link menubtn" data-toggle="dropdown"
                               aria-haspopup="true" aria-expanded="false">
                                <i class="fal fa-bars"></i>
                            </a>
                            <AdminMenu></AdminMenu>
                        </div>

                    </div>
                </div>
                <div class="container">
                    <router-view></router-view>
                </div>
            </div>
            <isAuthenticated :dataApi="api"></isAuthenticated>
        </div>


</template>




<style lang="scss">

    .form-control {
        option {
            background-color: #ffffff;
        }

    }

    .item-row {
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        line-height: 46px;
        height: 47px;
        padding-left: 10px;
        padding-right: 10px;

        &:last-child {
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        }

        a {
            color: #ffffff;
        }
        .drag-drop-icon {
            margin-right: 10px;
            color: rgba(255, 255, 255, 0.8);
        }

        .item-actions {
            float: right;

            a {
                color: #00c9ff;
            }
            i {
                margin-left: 10px;
                &.fa-trash {
                    color: #dc3545;
                }
                &:hover {
                    color: #ffffff;
                }
            }
        }
    }

    .dragArea .item-row {
        &:hover {
            cursor: all-scroll;
        }
        &.sortable-chosen {
            background: #1e1e2f;
        }
    }

    .m-navbar-top {
        margin-bottom: 20px;
    }

    .m-dropdown-nav .dropdown-menu * {
        -webkit-transition: all .5s ease 0s;
        transition: all .5s ease 0s;
    }

    .m-dropdown-nav .dropdown-menu.show {
        min-width: 225px;
        transform: translate3d(0px, 0px, 0px) !important;
        top: 75px !important;
        left: 0;
        background: #00c9ff;
        background: -webkit-gradient(linear, left bottom, left top, from(#004682), to(#00c9ff));
        background: linear-gradient(0deg, #004682, #00c9ff);
        z-index: 1;
        background-size: cover;
        background-position: 50%;
        -webkit-box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.2), 0 2px 30px 0 rgba(0, 0, 0, 0.35);
        box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.2), 0 2px 30px 0 rgba(0, 0, 0, 0.35);
        border-radius: 5px;
        padding: 0;

        &:before {
            content: "";
            position: absolute;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 6px solid #00c9ff;
            top: -5px;
            left: 24px;
            -webkit-transform: translate(-50%);
            transform: translate(-50%);
        }

        .m-dropdown-menu__logo {
            position: relative;
            padding: 1.5rem;
            z-index: 4;

            &:after {
                content: "";
                position: absolute;
                bottom: 0;
                right: 15px;
                height: 1px;
                width: calc(100% - 30px);
                background: rgba(255, 255, 255, 0.5);
            }

            .m-dropdown-menu__logo-img {
                text-align: center;

                img {
                    max-width: 40px;
                }
            }
        }
        .m-dropdown-menu__nav {
            margin-top: 20px;
            padding: 0 0 10px;
            list-style: none;

            li.m-aside-active,
            li.router-link-active,
            li.router-link-exact-active {
                background: rgba(255, 255, 255, 0.2);
            }

            li > a {
                margin: 0 20px;
                color: rgba(255, 255, 255, 0.8);
                display: block;
                position: relative;
                text-align: left;
                text-transform: uppercase;
                font-size: 1.4rem;
                padding: 8px 0;
                letter-spacing: 0.5px;
                line-height: 30px;
                white-space: nowrap;

                &:hover {
                    color: #fff;
                }
            }
        }
    }
</style>

<script>
    import {mapGetters, mapMutations} from 'vuex'
    import AdminMenu from './components/AdminMenu'

    export default {
        components: {
            AdminMenu,
        },
        data() {
            return {
                showMenu: false
            }
        },
        methods: {
            ...mapMutations(['setShowMenu'])
        },
        computed: {
            api(){
                return PORTAL_API
            },
            ...mapGetters([
                'getShowMenu'
            ]),
            ...mapGetters('root', [
                'getMockedCompany'
            ]),

        },
        created() {
            this.$store.dispatch('initApp')

            $('[data-toggle="tooltip"]').tooltip()

            if (this.$route.fullPath === "/") {
                this.$router.push('/products')
            }
        },

    }
</script>
